import { render, staticRenderFns } from "./schoolCooperation.vue?vue&type=template&id=4a4f91be&scoped=true"
import script from "./schoolCooperation.vue?vue&type=script&lang=js"
export * from "./schoolCooperation.vue?vue&type=script&lang=js"
import style0 from "./schoolCooperation.vue?vue&type=style&index=0&id=4a4f91be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f91be",
  null
  
)

export default component.exports